import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=573b555e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=573b555e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b555e",
  null
  
)

export default component.exports